import React, {useState, useEffect} from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import ContactosXempresaService from '@app/services/contactosXempresa.service';

const Styles = styled.div``;

const SelectContacto = ({
  id,
  value,
  onChange,
  isInvalid,
  isClearable,
  disabled,
  camera,
  emp
}) => {
    const [items, setItems] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState();

    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };

    useEffect(() => {
        let type= 'multi';
        if(camera){
            type= 'cvv'
        }
        ContactosXempresaService.select({type,emp}).then((response) => {
            setItems(response);
            const newOptions = response.map((item) => {
                if(camera){
                    return {
                      value: item.id_c,
                      label: item?.nombre_c,
                      ...item
                    };
                }
                    return {
                      value: item.id_cxe,
                      label: `${item?.contacto?.apellido_c}, ${item?.contacto?.nombre_c}`,
                      ...item
                    };
            });
            setOptions(newOptions);
            if (typeof value === 'string' || typeof value === 'number') {
                setSelectedValue(
                    newOptions.find((opt) => opt.value === Number(value))
                );
            }
        });
    }, []);
    return (
        <Styles>
            <Select
                inputId={id}
                className={`react-select-container ${
                    isInvalid ? 'is-invalid' : ''
                }`}
                isDisabled={disabled}
                styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
                menuPortalTarget={document.body}
                classNamePrefix="react-select"
                placeholder="Seleccione..."
                options={options}
                value={selectedValue}
                onChange={onSelectValue}
                isClearable={isClearable}
            />
        </Styles>
    );
};

SelectContacto.defaultProps = {
    isClearable: false
};

export default SelectContacto;
